<template>
  <div>
    <div class="blockHeader">
        <div class="redBlock"></div>
        <div class="headerText">验收意见</div>
    </div>
    <div class="comRollContent opinionCon">
        <div class="comItem">
            <div class="itemLeft">施工单位自评意见</div>
            <div class="itemRight">
                <el-input 
                    type="textarea"
                    placeholder="请输入..."
                    v-model="consUnitComment"
                    :disabled="inputPass_s"
                    @change="changeCons"
                ></el-input>
                <div class="dateShow">{{nowDate1}}</div>
            </div>
        </div>
        <div class="comItem">
            <div class="itemLeft">监理单位复合评定意见</div>
            <div class="itemRight">
                <div class="itemRightTop">
                    <el-input 
                        type="textarea"
                        placeholder="请输入..."
                        v-model="supervisorComment"
                        :disabled="inputPass_j"
                        @change="changeSuper"
                    ></el-input>
                    <div class="dateShow">{{nowDate2}}</div>
                </div>
                <div class="itemRightBottom">
                    <div class="itemRightBottomLeft">最终评定意见</div>
                    <div class="itemRightBottomRight">
                        <el-radio v-model="radio" label="1" :disabled="inputPass_j" @change="changeRadio">合格</el-radio>

                        <el-radio v-model="radio" label="0" :disabled="inputPass_j" @change="changeRadio">不合格</el-radio>

                    </div>
                </div>
            </div>
        </div>
        <div class="comItem">
            <div class="itemLeft">附件信息</div>
            <div class="itemRight">
                <el-upload
                    v-if="uploadShow"
                    class="upload-demo"
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview1"
                    :on-remove="handleRemove1"
                    :on-success="handleSuccess1"
                    :file-list="fileList"
                    :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>

                <el-upload
                    class="upload-demo"
                    ref="uploadNew"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :file-list="fileList_new"
                    :auto-upload="false">
                    <!-- <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
  import{
    deleteWorkFile
    } from '../../../utils/api'
    import axios from 'axios';
    import Cookies from 'js-cookie'
  export default {
    name      : 'app',
    data() {
      return {
          radio: '0',
          consUnitComment: '',
          supervisorComment: '',
          nowDate1: '',
          nowDate2: '',
          inputPass_s: true,
          inputPass_j: true,
          fileList:[],
          fileList_new: [],
          uploadShow: true
      }
    },
    props:{
        comments: {
            type: Object,
            default: function () {
                return {};
            },
        },
        attachments: {
            type: Array,
            default: function () {
                return [];
            },
        },
        workId: {
            type: String,
        },
        type: {
            type: String,
        },
    },
    watch:{
        comments: {
            handler(newV) {
                console.log(newV)
                this.consUnitComment = newV.consUnitComment ? newV.consUnitComment: ''
                this.supervisorComment = newV.supervisorComment ? newV.supervisorComment: ''
                this.nowDate1 = newV.consUnitDate ? newV.consUnitDate: ''
                this.nowDate2 = newV.supervisorDate ? newV.supervisorDate: ''
                this.radio = newV.passFlag ? newV.passFlag+'': '0'
            },
            immediate: true,
            deep:true
        },
        attachments: function(newV){
            let getList = newV
            let setList = []
            for(let i=0;i<getList.length;i++){
                let setObj = {
                    name: getList[i].originName,
                    url: getList[i].cosUrl,
                    uuid_names: getList[i].uuidName
                }
                setList.push(setObj)
            }
            this.fileList_new = setList
        }
    },
    computed:{

    },
    created(){

    },
    mounted(){
        let joinCode = localStorage.getItem("roleCode")
        if(joinCode == 'role-admin'){
            this.inputPass_s = false
            this.inputPass_j = false
        }else if(joinCode == 'role-1ee79e33cca14137a11514b861c1a199'){
            this.inputPass_s = false
            this.inputPass_j = true
        }else if(joinCode == 'role-7bb90c5570ae4fd8b029d2737f89b641'){
            this.inputPass_s = true
            this.inputPass_j = false
        }else{
            this.inputPass_s = true
            this.inputPass_j = true
            this.uploadShow = false
        }
        if(this.type == 'all'){
            this.inputPass_s = true
            this.inputPass_j = true
            this.uploadShow = false
        }
        // if(joinCode != 'role-1ee79e33cca14137a11514b861c1a199' && joinCode != 'role-7bb90c5570ae4fd8b029d2737f89b641'){
        //     this.inputPass_s = true
        //     this.inputPass_j = true
        //     this.uploadShow = false
        // }

        this.consUnitComment = this.comments.consUnitComment ? this.comments.consUnitComment: ''
        this.supervisorComment = this.comments.supervisorComment ? this.comments.supervisorComment: ''
        this.nowDate1 = this.comments.consUnitDate ? this.comments.consUnitDate: ''
        this.nowDate2 = this.comments.supervisorDate ? this.comments.supervisorDate: ''
        this.radio = this.comments.passFlag ? this.comments.passFlag+'': '0'


        let getList = this.attachments
            let setList = []
            for(let i=0;i<getList.length;i++){
                let setObj = {
                    name: getList[i].originName,
                    url: getList[i].cosUrl,
                    uuid_names: getList[i].uuidName
                }
                setList.push(setObj)
            }
            this.fileList_new = setList
    },
    methods: {
        changeCons(e){
            console.log(e)
            this.$emit('changeCons', e)
        },
        changeSuper(e){
            console.log(e)
            this.$emit('changeSuper', e)
        },
        changeRadio(e){
            console.log(e)
            this.$emit('changeRadio', e)
        },
        async submitUpload() {
            let that =this
            // this.$refs.upload.submit();
            console.log(this.$refs.upload)
            console.log(this.$refs.upload.uploadFiles);
            let dataV=new FormData();
            let fileArr=this.$refs.upload.uploadFiles;
            fileArr.map((item)=>{
                console.log(item)
                dataV.append('files',item.raw,item.raw.name)
            })
            console.log(dataV.get('files'))
            let config={
                headers:{'Content-Type':'multipart/form-data',token:Cookies.get('token'),Authorization:Cookies.get('token')},
                // responseType: 'blob',
            }
            const InstructionManualvv = await axios.post(that.$store.state.baseUrl+'/construction/attachment/work/file?workId='+that.workId,dataV,config)
            console.log(InstructionManualvv)
            if(InstructionManualvv.data.code == 200){
                this.$message({
                    message: '上传成功',
                    type: 'success'
                });
            }else{
                this.$message({
                    message: '上传失败',
                    type: 'warning'
                });
            }
            
            let getList = InstructionManualvv.data.content.dataList
            let setList = []
            for(let i=0;i<getList.length;i++){
                let setObj = {
                    name: getList[i].originName,
                    url: getList[i].cosUrl,
                    uuid_names: getList[i].uuidName
                }
                setList.push(setObj)
            }
            this.fileList = []
            this.fileList_new = this.fileList_new.concat(setList)
            // let params={
            //     workId: 46,
            //     files: this.$refs.upload.uploadFiles
            // }
            // setWorkFile(params).then(res=>{
            //     console.log(res)
            // })
        },
        handleRemove(file, fileList) {
            let that = this
            console.log(file, fileList);
            let params = {
                uuid_names: file.uuid_names
            }
            deleteWorkFile(params).then(res=>{
                console.log(res)
                if(res.data.code == 200){
                    that.fileList_new = fileList
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                }else{
                    that.fileList_new = that.fileList_new.concat([])
                }
            })
        },
        handlePreview(file) {
            window.open(file.url)
        },
        handleSuccess(file) {
            console.log(file);
        },

        handleRemove1(file, fileList) {
            console.log(file,fileList);
        },
        handlePreview1(file) {
            console.log(file);
        },
        handleSuccess1(file) {
            console.log(file);
        },
    },
    components:{
            
    }
  }
</script>
<style lang="scss">
    .opinionCon{
        .el-textarea{
            height: 100% !important;
            width: 100% !important;
            margin-top: 1px;
            .el-textarea__inner{
                height: 100% !important;
                width: 100% !important;
                border: 0;
                padding: 25px 29px;

            }
        }
    }
</style>
<style lang="scss" scoped="">
    .blockHeader{
      width: 100%;
      height: 58px;
      position: relative;
      .redBlock{
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #E96B5A;
          top: 19px;
          left: 20px;
        }
        .headerText{
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 34px;
          font-weight: 600;
        }
    }
    .comRollContent{
        width: 98.5%;
        margin: 0 auto;
        .comItem{
            width: 100%;
            height: 170px;
            border: 1px solid #E1E1E1;
            margin-bottom: 14px;
            .itemLeft{
                height: 100%;
                line-height: 170px;
                padding-left: 25px;
                width: 239px;
                background: #F1F1F5;
                font-size: 18px;
                font-weight: bold;
                color: #555555;
                float: left;
            }
            .itemRight{
                height: 99%;
                margin-left: 239px;
                position: relative;
                .dateShow{
                    height: 14px;
                    line-height: 14px;
                    position: absolute;
                    color: #555555;
                    font-size: 14px;
                    bottom: 15px;
                    right: 21px;
                }
                .itemRightTop{
                    height: 125px;
                    width: 100%;
                    position: relative;
                    .dateShow{
                        height: 14px;
                        line-height: 14px;
                        position: absolute;
                        color: #555555;
                        font-size: 14px;
                        bottom: 15px;
                        right: 21px;
                    }
                }
                .itemRightBottom{
                    width: 100%;
                    height: 45px;
                    .itemRightBottomLeft{
                        float: left;
                        height: 100%;
                        width: 239px;
                        background: #F1F1F5;
                        line-height: 45px;
                        padding-left: 22px;
                        color: #555555;
                        font-size: 14px;
                    }
                    .itemRightBottomRight{
                        margin-left: 239px;
                        height: 100%;
                        border-top: 1px solid #E1E1E1;
                        padding: 11px 68px;
                    }
                }
            }
        }
    }
</style>